import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import FieldConfigsForm from './fieldConfigsForm';
import GamesEdit from './gamesEdit';
import GamesForm from './gamesForm';
import GamesLogoUpload from './gamesLogoUpload';
import GamesIndex from './gamesIndex';

export default angular.module('app.components.admin.games', [
  'ui.router',
  FieldConfigsForm.name,
  GamesEdit.name,
  GamesForm.name,
  GamesLogoUpload.name,
  GamesIndex.name
])
  .config(function($stateProvider){
    $stateProvider
      .state('app.admin.games', {
        abstract: true,
        url: '/games',
        template: '<ui-view/>',
        data: {
          permissions: {
            only: ['ADMIN', 'GG_ACCOUNT_MANAGER', 'ADMIN_AGENCY', 'OPERATION_MANAGER']
          }
        }
      })
      .state('app.admin.games.index', {
        url: '',
        params: { gamesStatusFilterValue: null },
        template: '<admin-games-index></admin-games-index>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.games.index');
          }
        }
      })
      .state('app.admin.games.new', {
        url: '/new',
        template: '<admin-games-edit></admin-games-edit>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.games.new');
          }
        }
      })
      .state('app.admin.games.edit', {
        url: '/:id',
        template: '<admin-games-edit></admin-games-edit>',
        resolve: {
          $title: ($filter, $stateParams, GamesResource) => {
            return GamesResource.one($stateParams.id).get()
              .then((game) => $filter('translate')('$state.app.admin.games.edit', {name: game.name}));
          }
        }
      });
  })


/** WEBPACK FOOTER **
 ** ./src/components/admin/games/games.js
 **/